import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { PageHeader } from "@/components/common/PageHeader";
import { LoadingState, ErrorState } from "@/components/common/States";
import { OfPicker } from "@/components/atelier/OfPicker";
import { OfCockpit } from "@/components/atelier/OfCockpit";

const KEY = "prodtrack_atelier_of";

export default function AtelierPage() {
  const { user, entrepriseId } = useAuth();
  const [ofId, setOfId] = useState(() => Number(localStorage.getItem(KEY)) || null);
  const ready = user.role !== "superadmin" || !!entrepriseId;
  const list = useQuery({ queryKey: ["of-actifs", entrepriseId], queryFn: () => get("/of", { actifs: 1 }), refetchInterval: 10000, enabled: ready });

  useEffect(() => {
    if (list.data && ofId && !list.data.some((o) => o.id === ofId)) { setOfId(null); localStorage.removeItem(KEY); }
  }, [list.data, ofId]);

  const pick = (o) => { setOfId(o.id); localStorage.setItem(KEY, String(o.id)); };
  const clear = () => { setOfId(null); localStorage.removeItem(KEY); };

  return (
    <div data-testid="atelier-page">
      {!ofId && <PageHeader crumbs={[{ label: "ProdTrack" }, { label: "Production" }, { label: "Écran atelier" }]} title="Poste atelier — choisissez votre ordre de fabrication" subtitle={`Opérateur : ${user.nom} · ${list.data?.length ?? "…"} OF actif(s)`} />}
      {!ready ? <div className="panel p-4 text-xs text-muted-foreground">Sélectionnez une entreprise dans la barre supérieure.</div>
        : ofId ? <OfCockpit ofId={ofId} onChange={clear} />
        : list.isLoading ? <LoadingState /> : list.error ? <ErrorState error={list.error} onRetry={list.refetch} />
        : <OfPicker ofs={list.data} onPick={pick} />}
    </div>
  );
}
